import { createTheme } from '@mui/material/styles';

const RemoteControlTheme = createTheme({
    palette: {
        background: {
            default: '#000000',
            primary: '#000000',
            secondary: '#fff'
        },
        text: {
            default: '#fff',
            primary: '#fff',
            secondary: '#000000',
            tertiary: 'rgba(255, 255, 255, 0.7)'
        },
        primary: {
            main: '#fff'
        },
        secondary: {
            main: '#000000'
        },
        success: {
            main: '#ED5AE7'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
        body {
          margin: 0;
          padding: 0;
        },
        main {
          max-width: 600px;
          margin: 0 auto;
        },
        .img-logo {
            height: 36px;
        },
        .qr-code {
            border-radius: 12px;
        },
        .WidgetLogin {
            display: flex;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
      `
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    color: '#fff', margin: '0 auto'
                },
                h1: {
                    fontSize: '0.925rem', fontWeight: '600', lineHeight: '1.5rem', letterSpacing: '0.009rem'
                },
                h2: {
                    fontSize: '1.2rem',
                    fontWeight: '700',
                    lineHeight: '1.125rem'
                },
                h3: {
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    lineHeight: '1.5rem',
                    letterSpacing: '0.009rem'
                },
                p: {
                    fontSize: '0.8rem',
                    textAlign: 'left'
                }
            },
            variants: [{
                props: { variant: 'p-strong' },
                style: {
                    fontSize: '0.8rem',
                    textAlign: 'left',
                    fontWeight: 'bold'
                }
            }, {
                props: { variant: 'p-strong-left' },
                style: {
                    fontSize: '0.8rem',
                    textAlign: 'left',
                    fontWeight: 'bold',
                    marginLeft: '0'
                }
            }, {
                props: { variant: 'p-left' },
                style: {
                    fontSize: '0.8rem',
                    textAlign: 'left',
                    marginLeft: '0'
                }
            }, {
                props: { variant: 'header-text' },
                style: {
                    fontSize: '0.75rem',
                    fontWeight: '400',
                    lineHeight: '0.879rem',
                    display: 'block'
                }
            }, {
                props: { variant: 'account-title' },
                style: {
                    fontSize: '1rem',
                    fontWeight: '600',
                    margin: '0'
                }
            }, {
                props: { variant: 'live-event-schedule' },
                style: {
                    backgroundColor: '#222222',
                    whiteSpace: 'nowrap',
                    fontSize: '0.56rem',
                    textTransform: 'uppercase',
                    fontWeight: '700',
                    position: 'absolute',
                    margin: '.4rem',
                    left: '0',
                    bottom: '0',
                    padding: '0.1rem 0.25rem',
                    borderRadius: '3px'
                }
            }, {
                props: { variant: 'live-now-event' },
                style: {
                    backgroundColor: '#F96B81',
                    whiteSpace: 'nowrap',
                    fontSize: '0.56rem',
                    textTransform: 'uppercase',
                    fontWeight: '700',
                    position: 'absolute',
                    margin: '.4rem',
                    left: '0',
                    bottom: '0',
                    padding: '0.1rem 0.25rem',
                    borderRadius: '3px'
                }
            }, {
                props: { variant: 'live-now-parent' },
                style: {
                    backgroundColor: '#58EDB9',
                    whiteSpace: 'nowrap',
                    fontSize: '0.56rem',
                    textTransform: 'uppercase',
                    fontWeight: '700',
                    position: 'absolute',
                    margin: '.4rem',
                    left: '0',
                    top: '0',
                    padding: '0.1rem 0.25rem',
                    borderRadius: '3px',
                    color: '#21445E'
                }
            }, {
                props: { variant: 'live-event-name' },
                style: {
                    fontSize: '12px',
                    fontWeight: '400',
                    lineHeight: '15px',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: '3',
                    whiteSpace: 'pre-wrap',
                    margin: '0'
                }
            }, {
                props: { variant: 'live-event-card-actions-caption' },
                style: {
                    width: '3.3rem',
                    fontSize: '0.5rem',
                    fontWeight: '400',
                    lineHeight: '0.563rem',
                    textAlign: 'center',
                    letterSpacing: '0.02em',
                    paddingTop: '2px'
                }
            }, {
                props: { variant: 'ellipsis' },
                style: {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                }
            }, {
                props: { variant: 'date-title' },
                style: {
                    fontSize: '12px',
                    fontWeight: '600',
                    lineHeight: '15px',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: '3',
                    whiteSpace: 'pre-wrap',
                    margin: '0',
                    textTransform: 'uppercase'
                }
            }, {
                props: { variant: 'landing-text' },
                style: {
                    fontSize: '32px',
                    textAlign: 'center'
                }
            }]
        },
        MuiAlertTitle: {
            styleOverrides: {
                root: {
                    textTransform: 'capitalize'
                }
            }
        },
        MuiBottomNavigation: {
            styleOverrides: {
                root: {
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(0, 0, 0)',
                    paddingBottom: '22px'
                }
            }
        },
        MuiBottomNavigationAction: {
            variants: [{
                props: { variant: 'selected' },
                style: {
                    color: 'white',
                    label: { fontSize: '2px' }
                }
            }, {
                props: { variant: 'deselected' },
                style: {
                    color: 'grey',
                    label: { fontSize: '2px' }
                }
            }]

        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: 'linear-gradient(121.57deg, #000000 19.01%, #0D1C49 87.95%)',
                    height: '84px',
                    marginBottom: '18px',
                    animation: 'fadeInDown ease-in-out 1s'
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    width: '100%',
                    maxWidth: '600px',
                    margin: '0 auto',
                    justifyContent: 'space-between',
                    height: '100%',
                    padding: '0 18px'
                }
            },
            variants: [{
                props: { variant: 'sidebar' },
                style: {
                    height: '84px'
                }
            }]

        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#212121',
                    width: '100dvw',
                    margin: '0 auto'
                }
            }

        },
        MuiList: {
            styleOverrides: {
                root: {
                    margin: '0 0 60px 0',
                    padding: '0'
                }
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    margin: '8px 18px',
                    padding: '0',
                    borderRadius: '4px',
                    backgroundColor: '#000000',
                    width: 'auto'
                }
            },
            variants: [{
                props: { variant: 'devices' },
                style: {
                    display: 'flex',
                    alignItems: 'center'
                }
            }]
        },
        MuiListItemText: {
            variants: [{
                props: { variant: 'ellipsis' },
                style: {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                }
            }]
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&.Mui-selected, &.Mui-selected:hover': {
                        borderRadius: '4px',
                        backgroundColor: '#ED5AE7'
                    }
                }
            },
            variants: [{
                props: { variant: 'devices' },
                style: {
                    padding: '12px 18px',
                    width: '100%'
                }
            }]
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: '#fff'
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: '#fff'
                }
            },
            variants: [{
                props: { variant: 'event_overlap' },
                style: {
                    position: 'absolute',
                    margin: '6px',
                    right: '0',
                    top: '0',
                    padding: '4px',
                    backgroundColor: '#DE425B',
                    borderRadius: '3px'
                }
            }, {
                props: { variant: 'logout' },
                style: {
                    display: 'flex',
                    gap: '8px',
                    paddingRight: '10px',
                    borderRadius: '8px',
                    borderColor: '#ED5AE7',
                    borderWidth: '2px',
                    borderStyle: 'solid'
                }
            }]
        },
        MuiStack: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiCard: {
            variants: [{
                props: { variant: 'live-event' },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#212121',
                    height: '160px',
                    boxShadow: '0px 2.6345832347869873px 2.6345832347869873px 0px #00000040'
                }
            }, {
                props: { variant: 'live-event-disabled' },
                style: {
                    background: 'black',
                    opacity: '0.6'
                }
            }]
        },
        MuiCardMedia: {
            styleOverrides: {
                root: {
                    width: '100%',
                    height: '106px'
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {}
            },
            variants: [{
                props: { variant: 'live-event' },
                style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    margin: 'auto',
                    '&:last-child': {
                        padding: '0 0.6rem'
                    },
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }
            }]
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    margin: '0',
                    padding: '0',
                    backgroundColor: '#fff'
                }
            },
            variants: [{
                props: { variant: 'account-menu' },
                style: {
                    borderColor: '#212121',
                    borderWidth: '1px',
                    margin: '0 18px'
                }
            }]
        },
        MuiDialogTitle: {
            variants: [{
                props: { variant: 'drawer-dialog-title' },
                style: {
                    display: 'flex',
                    margin: '0',
                    padding: '1.5vh'
                }
            }]
        },
        MuiDialogContent: {
            variants: [{
                props: { variant: 'drawer-dialog-content' },
                style: {
                    display: 'flex',
                    margin: '0',
                    paddingTop: '1vh'
                }
            }]
        },
        MuiCircularProgress: {
            variants: [{
                props: { variant: 'indeterminate' },
                style: {
                    marginRight: '7px'
                }
            }]
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    flexDirection: 'column',
                    padding: 0,
                    marginLeft: '0.6rem'
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#222222',
                    color: '#fff',
                    width: '100%'
                }
            },
            variants: [{
                props: { variant: 'searchbar' },
                style: {
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    width: 'auto',
                    marginRight: '0.8rem',
                    marginLeft: '0.8rem',
                    borderRadius: '2rem',
                    margin: '0 18px 18px 18px'
                }
            }]
        },
        MuiInput: {
            variants: [{
                props: { variant: 'searchbar' },
                style: {
                    color: 'black',
                    paddingRight: '1rem',
                    paddingLeft: '1rem',
                    height: '40px',
                    verticalAlign: 'middle'
                }
            }]
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    margin: '0',
                    padding: '0 18px'
                }
            },
            variants: [{
                props: { variant: 'event-loader-wrapper' },
                style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'black',
                    opacity: '0.5',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            }, {
                props: { variant: 'center-wrapper' },
                style: {
                    margin: '0',
                    padding: '0',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100dvh'
                }
            }, {
                props: { variant: 'wrapper-sidebar' },
                style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '0 18px 18px 18px'
                }
            }, {
                props: { variant: 'wrapper-sidebar-title' },
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '18px'
                }
            }, {
                props: { variant: 'bottom-menu' },
                style: {
                    marginTop: '5rem',
                    animation: 'fadeInUp ease-in-out 0.4s'
                }
            }, {
                props: { variant: 'h-center-wrapper' },
                style: {
                    display: 'flex',
                    margin: 'auto 0'
                }
            }, {
                props: { variant: 'wrapper-sidebar-left' },
                style: {
                    paddingLeft: '0 !important',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }, {
                props: { variant: 'events' },
                style: {
                    marginBottom: '40px',
                    animation: 'fadeInUpBig ease-in-out 0.6s',
                    height: 'calc(100dvh - 168px)',
                    overflow: 'auto'
                }
            }, {
                props: { variant: 'drawer-header' },
                style: {
                    display: 'flex',
                    margin: '18px 0',
                    fontSize: '1.13rem',
                    fontWeight: '700'
                }
            }, {
                props: { variant: 'landing' },
                style: {
                    background: 'radial-gradient(44.22% 44.22% at 50% 50%, #060C33 0%, #000000 100%)',
                    margin: 'auto',
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-evenly'
                }
            }, {
                props: { variant: 'qr-container' },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px'
                }
            }]
        },
        MuiGrid: {
            styleOverrides: {
                container: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '1.5vh',
                    marginTop: '1.2vh',
                    marginBottom: '3vh'
                },
                root: {
                    maxWidth: 'none',
                    flexBasis: 'auto'
                },
                item: {
                    width: '100%'
                }
            }
        }
    }
});

export default RemoteControlTheme;
